import { RolloverStatusDetails } from "../../../api-client-nswag/rollover-client";

export interface ModalRolloverStatusDetailsProps {
  rolloverId: number;
  isDisplayModal: boolean;
  handleClose: any;
}

export interface RolloverStatusDetailsState {
  pending: boolean;
  fulfilled: boolean;
  details: RolloverStatusDetails[];
}

export const EXECUTION_DETAILS_TITLE = "Execution details";

export const titles = {
  ENTITY_NAME: "Entity Name",
  STEP: "Step",
  STATUS: "Status",
  STATUS_MESSAGE: "Status Message",
};

export const STEP_DISPLAY_NAMES: Record<string, string> = {
    Create_Archival_Folder: "Create Archive Folder",

    Generate_Index_Files: "Generate Index Files",

    Sync_Site_Files: "Sync Site Files",

    Move_Document_To_Archive_Folder: "Move Document to Archive Folder",

    Upload_Archival_Folders_To_Storage: "Upload Archive to Storage",

    Move_Retained_Documents_To_Site: "Move Retained Documents to Site",

    Upload_File_To_SharePoint: "Upload File to SharePoint",

    Delete_Archival_Folder_From_Site: "Remove Archive Folder",

    ISheet_Rollover: "iSheet Rollover",

    Upload_File_To_Storage: "Upload File to Storage",

    Update_ISheet_Data: "Update iSheet Data",

    Update_SiteConfig: "Update Site Configuration",

    // Old flow
    Copy_To_Archival_Folder: "Copy Files to Archive",

    Update_Source_Folders_In_Folder_Mappings: "Update Folder Mappings",

    Delete_Source_Files_From_Site: "Remove Source Files" 
};
 